import './plugins/jquery';

import { toHTML } from './functions/to-html';
import { refeashObfuscate } from './functions/obfuscate';

export default {
  toHTML,
  refeashObfuscate,
};
